import React, { PureComponent, Component } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import { Redirect, withRouter } from 'react-router-dom';

import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import SuperAdminHeader from './../../components/Header/SuperAdmin';
// import { Navbar, NavbarToggler, Collapse, Nav, NavItem, DropdownMenu, Dropdown, DropdownToggle, DropdownItem } from 'reactstrap';
import Footer from './../../components/Footer';
import FilterSorter from './../../components/FilterSorter';


const sortFuncGen = (property, direction) => {
  const up = direction === "asc" ? 1 : -1
    , down = direction === "asc" ? -1 : 1
  return ((a, b) => a.invoice[property] < b.invoice[property] ? down : up)
}

class PaymentsPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      viewInvoiceModalOpen: false,
      viewedInvoice: null,
      invoices: [],
      filteredInvoices: [],
      sortByIndex: 0,
      filterByIndex: 0,
      merchantFilterIndex: 0,
      domainFilterIndex: 0
    }
    autobind(this);
    this.sortbyItems = [
      { name: "Invoice Date (desc)", sortFunc: sortFuncGen("invoiceDate", "desc"), onSelect: this.sortby },
      { name: "Invoice Date (asc)", sortFunc: sortFuncGen("invoiceDate", "asc"), onSelect: this.sortby },
      { name: "Due Date (desc)", sortFunc: sortFuncGen("dueDate", "desc"), onSelect: this.sortby },
      { name: "Due Date (asc)", sortFunc: sortFuncGen("dueDate", "asc"), onSelect: this.sortby },
      { name: "Amount (desc)", sortFunc: sortFuncGen("amount", "desc"), onSelect: this.sortby },
      { name: "Amount (asc)", sortFunc: sortFuncGen("amount", "asc"), onSelect: this.sortby },
      { name: "Paid", sortFunc: sortFuncGen("payed", "asc"), onSelect: this.sortby },
    ]

    this.filterByItems = [
      { name: "All", filterFunc: (i) => true, onSelect: this.filterby },
      { name: "Amount > 0", filterFunc: (i) => i.invoice.amount !== 0, onSelect: this.filterby },
      { name: "Amount = 0", filterFunc: (i) => i.invoice.amount === 0, onSelect: this.filterby },
      { name: "Not paid", filterFunc: (i) => !i.invoice.payed, onSelect: this.filterby },
      { name: "Due", filterFunc: (i) => !i.invoice.payed && new Date() <= new Date(i.invoice.dueDate), onSelect: this.filterby },
      { name: "Past Due", filterFunc: (i) => !i.invoice.payed && new Date() > new Date(i.invoice.dueDate), onSelect: this.filterby },
    ]

    this.filterByMerchantItems = [
      { name: "All", filterFunc: (i) => true, onSelect: this.merchantfilterby },
    ]

    this.filterByDomainItems = [
      { name: "All", filterFunc: (i) => true, onSelect: this.domainfilterby },
    ]
  }


  componentDidMount() {
    this.props.getMerchants()
  }
  toggle(target) {
    const field = `dropdownOpen${target}`
    this.setState({ [field]: !this.state[field] })
  }
  componentWillReceiveProps(props) {

    const merchants = []
      , domains = []
    const invoices = props.merchants.reduce((acc, m) => {
      const { _id: merchantId, invoices, subscriptionsHistory, paymentDetails, contactPersons: contact, username, email } = m
        , { companyName, CUI, accountNumber } = paymentDetails || { companyName: [username, email].join(', '), CUI: "", accountNumber: "" }
      merchants.push({ merchantId, companyName })
      invoices.forEach((invoice, index) => {
        // if (!invoice.payed) {
        const domain = invoice.subscription.domain.name
          , { subscriptionSettingId } = invoice
        if (-1 === domains.indexOf(domain)) {
          domains.push(domain)
        }
        acc.push({ subscriptionSettingId, merchantId, invoice, domain, contact, username, email, subscriptionsHistory, companyName, CUI, accountNumber, nr: index + 1 })
        // }
      })
      return acc
    }, [])

    this.filterByMerchantItems = [
      this.filterByMerchantItems[0],
      ...merchants.map(m => ({
        name: m.companyName, filterFunc: (i) => i.merchantId === m.merchantId, onSelect: this.merchantfilterby
      }))
    ]

    this.filterByDomainItems = [
      this.filterByDomainItems[0],
      ...domains.map(d => ({
        name: d, filterFunc: (i) => i.domain === d, onSelect: this.domainfilterby
      }))
    ]

    const { sortByIndex, filterByIndex, domainFilterIndex, merchantFilterIndex } = this.state
    , filteredInvoices = invoices.slice(0)
      .sort(this.sortbyItems[sortByIndex].sortFunc)
      .filter(this.filterByMerchantItems[merchantFilterIndex].filterFunc)
      .filter(this.filterByDomainItems[domainFilterIndex].filterFunc)
      .filter(this.filterByItems[filterByIndex].filterFunc)

    this.setState({ invoices: filteredInvoices, filteredInvoices })
  }

  onSwitch(index) {
    const { filteredInvoices } = this.state
      , invoiceData = filteredInvoices[index]
      , { merchantId, subscriptionSettingId, invoice: { payed: isPayed } } = invoiceData
    this.props.updateSubscriptionPayment(merchantId, subscriptionSettingId, !isPayed, () => {
      this.props.getMerchants()
    })
  }

  // showViewInvoiceModal(invoiceIndex) {

  //   const invoice = this.state.invoices[invoice.index]

  //   this.setState({
  //     viewedInvoice: invoice,
  //     viewInvoiceModalOpen: true
  //   })
  // }

  // hideViewInvoiceModal(){
  //   this.setState({viewInvoiceModalOpen:false, viewedInvoice: null})
  // }

  sortby(sortByIndex) {
    const { invoices, filterByIndex, merchantFilterIndex, domainFilterIndex } = this.state
      , filteredInvoices = invoices.slice(0)
        .sort(this.sortbyItems[sortByIndex].sortFunc)
        .filter(this.filterByMerchantItems[merchantFilterIndex].filterFunc)
        .filter(this.filterByDomainItems[domainFilterIndex].filterFunc)
        .filter(this.filterByItems[filterByIndex].filterFunc)
    this.setState({ sortByIndex, filteredInvoices })
  }

  filterby(filterByIndex) {
    const { invoices, sortByIndex, merchantFilterIndex , domainFilterIndex} = this.state
      , filteredInvoices = invoices.slice(0)
        .sort(this.sortbyItems[sortByIndex].sortFunc)
        .filter(this.filterByMerchantItems[merchantFilterIndex].filterFunc)
        .filter(this.filterByDomainItems[domainFilterIndex].filterFunc)
        .filter(this.filterByItems[filterByIndex].filterFunc)
    this.setState({ filterByIndex, filteredInvoices })
  }

  merchantfilterby(merchantFilterIndex) {
    const { invoices, sortByIndex, filterByIndex, domainFilterIndex } = this.state
      , filteredInvoices = invoices.slice(0)
        .sort(this.sortbyItems[sortByIndex].sortFunc)
        .filter(this.filterByMerchantItems[merchantFilterIndex].filterFunc)
        .filter(this.filterByDomainItems[domainFilterIndex].filterFunc)
        .filter(this.filterByItems[filterByIndex].filterFunc)
    this.setState({ filteredInvoices, merchantFilterIndex })
  }

  domainfilterby(domainFilterIndex) {
    const { invoices, sortByIndex, filterByIndex, merchantFilterIndex } = this.state
      , filteredInvoices = invoices.slice(0)
        .sort(this.sortbyItems[sortByIndex].sortFunc)
        .filter(this.filterByMerchantItems[merchantFilterIndex].filterFunc)
        .filter(this.filterByDomainItems[domainFilterIndex].filterFunc)
        .filter(this.filterByItems[filterByIndex].filterFunc)
    this.setState({ filteredInvoices, domainFilterIndex })
  }

  render() {

    const {
      // invoices,
      filteredInvoices
      // viewedInvoice
    } = this.state;
    const { impersonating } = this.props;

    // let viewedInvoiceData = {}
    // if(viewedInvoice) {
    //   const {
    //     invoice, domain, companyName, nr,
    //     // merchantId,
    //     CUI, accountNumber,
    //     // _id
    //   } = viewedInvoice
    //   const date = new Date(invoice.invoiceDate)
    //     , dueDate = new Date(invoice.dueDate)
    //     , now = new Date()
    //     , formatedInvDate = date.toLocaleDateString('en-us', { day: 'numeric', month: 'long', year: 'numeric' })
    //     , formatedInvTime = date.toLocaleTimeString('en-us', { hour: 'numeric', minute: 'numeric' })
    //     , formatedDueDate = dueDate.toLocaleDateString('en-us', { day: 'numeric', month: 'long', year: 'numeric' })
    //     , formatedDueTime = dueDate.toLocaleTimeString('en-us', { hour: 'numeric', minute: 'numeric' })
    //     , status = invoice.payed ? "Paid" : now < dueDate ? "Due" : "Past Due"

    //   viewedInvoiceData = {domain, companyName, nr, CUI, accountNumber}
    // }

    if (impersonating) {
      return <Redirect to="/dashboard" />
    }

    return (<div className="superadmin">
      <SuperAdminHeader />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <div className="items-list-filters align-items-center justify-content-between">
              <h4 className="mb-0">Payments ({filteredInvoices.length})</h4>
              <FilterSorter options={[
                {
                  type: "dropdown",
                  name: "merchant",
                  title: "Merchant",
                  selectedIndex: this.state.merchantFilterIndex,
                  items: this.filterByMerchantItems,
                  isOpen: this.state[`dropdownOpenmerchant`],
                  toggle: () => this.toggle('merchant')
                },
                {
                  type: "dropdown",
                  name: "domain",
                  title: "Module",
                  selectedIndex: this.state.domainFilterIndex,
                  items: this.filterByDomainItems,
                  isOpen: this.state[`dropdownOpendomain`],
                  toggle: () => this.toggle('domain')
                },
                {
                  type: "dropdown",
                  name: "sortby",
                  title: "Sort by",
                  selectedIndex: this.state.sortByIndex,
                  items: this.sortbyItems,
                  isOpen: this.state[`dropdownOpensortby`],
                  toggle: () => this.toggle('sortby')
                },
                {
                  type: "dropdown",
                  name: "show",
                  title: "Show",
                  selectedIndex: this.state.filterByIndex,
                  items: this.filterByItems,
                  isOpen: this.state[`dropdownOpenshow`],
                  toggle: () => this.toggle('show')
                },

              ]} />
            </div>
          </div>
        </div>
        <div className="items-list items-list--invoices">
          <div className="items-labels">
            <div className="items-label-1">Details</div>
            <div className="items-label-2">Issued To</div>
            <div className="items-label-3">Created</div>
            <div className="items-label-4">Payment Due</div>
            <div className="items-label-5">Amount</div>
            <div className="items-label-5">Status</div>
            <div className="items-label-6">Actions</div>
          </div>
          {filteredInvoices.map((invoiceData, index) => {
            return <InvoiceListItem
              key={invoiceData.invoice._id}
              invoiceData={invoiceData}
              onToggle={() => this.onSwitch(index)}
            // onView={() => this.showViewInvoiceModal(index)} 
            />
          })}
        </div>
      </div>
      <Modal isOpen={this.state.viewInvoiceModalOpen} toggle={this.hideViewInvoiceModal} className="modal-md superadmin">
        <ModalHeader>
          <span onClick={this.hideViewInvoiceModal} className="s7-close modal-close"></span>
        </ModalHeader>
        <ModalBody className="pt-0">
          WIP
        </ModalBody>
      </Modal>
      <Footer /></div>);
  }

}


class InvoiceListItem extends PureComponent {
  render() {
    const {
      invoice, domain, companyName, nr,
      // merchantId,
      // CUI, accountNumber,
      // _id
    } = this.props.invoiceData
    const date = new Date(invoice.invoiceDate)
      , dueDate = new Date(invoice.dueDate)
      , now = new Date()
      , formatedInvDate = date.toLocaleDateString('en-us', { day: 'numeric', month: 'long', year: 'numeric' })
      , formatedInvTime = date.toLocaleTimeString('en-us', { hour: 'numeric', minute: 'numeric' })
      , formatedDueDate = dueDate.toLocaleDateString('en-us', { day: 'numeric', month: 'long', year: 'numeric' })
      , formatedDueTime = dueDate.toLocaleTimeString('en-us', { hour: 'numeric', minute: 'numeric' })
      , status = invoice.payed ? "Paid" : now < dueDate ? "Due" : "Past Due"
      , statusClass = invoice.payed ? "status-paid" : now < dueDate ? "status-due" : "status-past-due"
    return (
      <div className="items-list-item items-list-item--invoices">
        <div className="list-item-1 flex-column justify-content-center align-items-start">
          Invoice #{nr}<br />{domain}
        </div>
        <div className="list-item-2">
          <div className="product-details">
            <span className="name">{companyName}</span>
          </div>
        </div>
        <div className="list-item-3 list-item-date">
          <div><span className="date">{formatedInvDate}</span><span className="time description">{formatedInvTime}</span></div>
        </div>
        <div className="list-item-4 list-item-date">
          <div><span className="date">{formatedDueDate}</span><span className="time description">{formatedDueTime}</span></div>
        </div>
        <div className="list-item-5">
          <div className={statusClass}> {invoice.amount}€</div>
        </div>
        <div className="list-item-5">
          <div className={statusClass}> {status} </div>
        </div>
        <div className="list-item-6 list-item-actions justify-content-center">
          <span className={"ar-icon s7-" + (invoice.payed ? "back" : "check")} onClick={this.props.onToggle} ></span>
          {/* <span className="ar-icon s7-eye" onClick={this.props.onView} ></span> */}
        </div>
      </div>
    )
  }
}

export default connect(
  (state, ownProps) => {
    const { merchants: { merchants, error }, auth: { impersonating } } = state
    return { merchants, error, impersonating }
  },
  actions,
  (stateProps, dispatchProps) => {
    return Object.assign({}, stateProps, dispatchProps)
  }
)(withRouter(PaymentsPage))



// WEBPACK FOOTER //
// ./src/containers/SuperAdmin/Invoices.js